import type {LucideIcon} from 'lucide-react'
import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface EmptyStateProps {
    icon?: LucideIcon
    title: string
    description?: string
    action?: ReactNode
    variant?: 'inline' | 'card'
    'data-testid'?: string
}

export function EmptyState({icon: Icon, title, description, action, variant = 'inline', 'data-testid': testId}: EmptyStateProps) {
    const isCard = variant === 'card'

    return (
        <div
            data-testid={testId ?? 'empty-state'}
            className={cn(
                'text-center',
                isCard
                    ? 'bg-card border rounded-lg p-8'
                    : 'flex flex-col items-center justify-center py-16'
            )}
        >
            {Icon && (
                <div data-testid="empty-state-icon" className="h-12 w-12 mx-auto mb-4">
                    <Icon className="h-full w-full text-muted-foreground"/>
                </div>
            )}
            <p data-testid="empty-state-title" data-help-anchor="true" className="text-lg font-medium mb-2">
                {title}
            </p>
            {description && (
                <p data-testid="empty-state-description" className="text-sm text-muted-foreground mb-4">
                    {description}
                </p>
            )}
            {action && (
                <div data-testid="empty-state-action" className="mt-2">
                    {action}
                </div>
            )}
        </div>
    )
}
